import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { NavLink } from 'react-router-dom';

export default function Navbar(props) {
  const handleOnClick = () => {
    const list = document.getElementById('list');
    if (list.classList.contains('hidden')) {
      list.classList.remove('hidden');
    } else {
      list.classList.add('hidden');
    }
  };
  return (
    <nav className="flex items-center flex-wrap lg:pt-[2%] pt-[3%] lg:pb-[2%] pb-[3%]">
      <a href="#" className="mr-4 inline-flex items-center">
        <div className="z-40">
          <p className="text-primary font-normal text-2xl">
            visit<span className="font-medium">Tegal</span>
          </p>
        </div>
      </a>
      <button className="inline-flex lg:hidden ml-auto text-3xl z-40" onClick={handleOnClick}>
        <FontAwesomeIcon icon={faBars} />
      </button>
      <div className="hidden w-full lg:flex lg:flex-grow lg:w-auto z-0 lg:z-40" id="list">
        <ul className="flex lg:flex-row flex-col lg:items-center lg:ml-auto items-start">
          <li className="cursor-pointer lg:my-0 my-2">
            <NavLink
              to="/"
              exact="true"
              className={({ isActive }) =>
                isActive
                  ? 'text-primary lg:px-5 lg:text-sm text-xs hover:text-primary duration-500'
                  : 'text-main lg:px-5 lg:text-sm text-xs hover:text-primary duration-500'
              }>
              Beranda
            </NavLink>
          </li>
          <li className="cursor-pointer lg:my-0 my-2">
            <NavLink
              to="/wisatabudaya"
              className={({ isActive }) =>
                isActive
                  ? 'text-primary lg:px-5 lg:text-sm text-xs hover:text-primary duration-500'
                  : 'text-main lg:px-5 lg:text-sm text-xs hover:text-primary duration-500'
              }>
              Wisata & Budaya
            </NavLink>
          </li>
          <li className="cursor-pointer lg:my-0 my-2">
            <NavLink
              to="/event"
              className={({ isActive }) =>
                isActive
                  ? 'text-primary lg:px-5 lg:text-sm text-xs hover:text-primary duration-500'
                  : 'text-main lg:px-5 lg:text-sm text-xs hover:text-primary duration-500'
              }>
              Event
            </NavLink>
          </li>
          <li className="cursor-pointer lg:my-0 my-2">
            <NavLink
              to="/explore"
              className={({ isActive }) =>
                isActive
                  ? 'text-primary lg:px-5 lg:text-sm text-xs hover:text-primary duration-500'
                  : 'text-main lg:px-5 lg:text-sm text-xs hover:text-primary duration-500'
              }>
              Explore
            </NavLink>
          </li>
          <li className="cursor-pointer lg:my-0 my-2">
            <NavLink
              to="/kontributor"
              className={({ isActive }) =>
                isActive
                  ? 'text-primary lg:px-5 lg:text-sm text-xs hover:text-primary duration-500'
                  : 'text-main lg:px-5 lg:text-sm text-xs hover:text-primary duration-500'
              }>
              Kontributor
            </NavLink>
          </li>
          <NavLink
            to="/register"
            className="bg-primary cursor-pointer px-8 py-2 lg:ml-5 lg:mb-0 mb-5 lg:mt-0 mt-2 rounded text-white lg:text-sm text-xs">
            Daftar
          </NavLink>
        </ul>
      </div>
    </nav>
  );
}
